import React from "react";
import { Carousel, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import bannerData from "../../../data/homeBanner";
import { useTranslation } from "react-i18next";
import "./HomeBanner.css";

export default function HomeBanner() {
  const { t } = useTranslation();

  return (
    <section className="hb">
      <Carousel
        className="hb-carousel"
        indicators
        controls
        interval={7000}
        pause="hover"
        fade={false}
        variant="dark"
      >
        {bannerData.map((item) => {
          const title = item.i18nKey ? t(`${item.i18nKey}.bannerTitle`) : "";
          const subtitle = item.i18nKey ? t(`${item.i18nKey}.bannerSubtitle`) : "";
          const ctaText = item.i18nKey ? t(`${item.i18nKey}.bannerCTA`) : "";

          return (
            <Carousel.Item className="hb-slide" key={item.id}>
              <SlideMedia item={item} />

              <div className="hb-overlay">
                <Container fluid="lg" className="hb-overlay__container">
                  <div className="hb-overlay__content">
                    {title ? <h3 className="hb-title">{title}</h3> : null}
                    {subtitle ? <p className="hb-subtitle">{subtitle}</p> : null}

                    {ctaText && item.ctaHref ? (
                      <div className="hb-cta">
                        <Link to={item.ctaHref} className="lk-brand-btn-1">
                          {ctaText}
                        </Link>
                      </div>
                    ) : null}
                  </div>
                </Container>
              </div>
            </Carousel.Item>
          );
        })}
      </Carousel>
    </section>
  );
}

function SlideMedia({ item }) {
  const [useImageFallback, setUseImageFallback] = React.useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  if (item.type === "video" && !useImageFallback && !prefersReducedMotion) {
    return (
      <div className="hb-media">
        <video
          className="hb-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster={item.poster || item.fallbackImg || undefined}
          onError={() => setUseImageFallback(true)}
        >
          <source src={item.videoSrc} type="video/mp4" />
        </video>
      </div>
    );
  }

  const imgSrc =
    item.imageSrc ||
    item.poster ||
    item.fallbackImg ||
    "/assets/images/banner-fallback-generic.jpg";

  return (
    <div className="hb-media">
      <img className="hb-img" src={imgSrc} alt="Banner" />
    </div>
  );
}

function usePrefersReducedMotion() {
  const [reduced, setReduced] = React.useState(false);
  React.useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReduced(!!mq.matches);
    update();
    mq.addEventListener?.("change", update);
    return () => mq.removeEventListener?.("change", update);
  }, []);
  return reduced;
}
